import ModalContext from 'contexts/ModalContext'
import type { ComponentProps } from 'react'
import { useCallback, useContext } from 'react'
import LoyaltyGenericInfoModal from '../LoyaltyGenericInfoModal'
import _LoyaltyPointsEarn from './_LoyaltyPointsEarn'

type InheritedPriceRowLoyaltyPointsProps = Omit<ComponentProps<typeof _LoyaltyPointsEarn>, 'onInfoIconClick'>

interface Props extends InheritedPriceRowLoyaltyPointsProps {
  /** If true, do not render the info icon/modal trigger */
  hideInfoIcon?: boolean
}

function LoyaltyPointsEarn({ calculationRequests, hideInfoIcon, offer, ...rest }: Props) {
  const showModal = useContext(ModalContext)
  const handleInfoClick = useCallback(() => {
    showModal(<LoyaltyGenericInfoModal offer={offer} />)
  }, [offer, showModal])

  return <_LoyaltyPointsEarn
    {...rest}
    offer={offer}
    calculationRequests={calculationRequests}
    onInfoIconClick={hideInfoIcon ? undefined : handleInfoClick}
  />
}

export default LoyaltyPointsEarn
